import { api, hasBackend } from "./api";
import type { UserProfile, ReminderPrefs } from "@/types";

export async function fetchProfile(): Promise<UserProfile | null> {
  if (!hasBackend()) return null;
  return api.get<UserProfile>("/api/v1/profile");
}

export async function updateProfile(data: Partial<UserProfile>): Promise<UserProfile> {
  if (!hasBackend()) return data as UserProfile;
  return api.patch<UserProfile>("/api/v1/profile", data);
}

export async function fetchReminderPrefs(): Promise<ReminderPrefs> {
  if (!hasBackend()) return { daysBefore: [1, 3, 7], emailEnabled: true, pushEnabled: true, smsEnabled: false };
  return api.get<ReminderPrefs>("/api/v1/profile/reminders");
}

export async function saveReminderPrefs(prefs: ReminderPrefs): Promise<ReminderPrefs> {
  if (!hasBackend()) return prefs;
  return api.put<ReminderPrefs>("/api/v1/profile/reminders", prefs);
}
